import { render, staticRenderFns } from "./paysal.vue?vue&type=template&id=244dd4fa&scoped=true"
import script from "./paysal.vue?vue&type=script&lang=js"
export * from "./paysal.vue?vue&type=script&lang=js"
import style0 from "./paysal.vue?vue&type=style&index=0&id=244dd4fa&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244dd4fa",
  null
  
)

export default component.exports